import React from "react";
import { ILicenseTypeSelection } from "components/licence/LicenseTypeProvider";
import { FieldPath, FieldValues, UseControllerProps } from "react-hook-form";
import { FormSelect } from "shared/components/newFormInputs/FormSelect";
import { TranslatedUseControllerOptions } from "shared/validations/useTranslatedValidations";

interface IProps<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>>
    extends Omit<UseControllerProps<TFieldValues, TFieldName>, "disabled" | "defaultValue" | "rules"> {
    licenseTypes: ILicenseTypeSelection[];
    isLoading: boolean;
    rules?: TranslatedUseControllerOptions<TFieldValues, TFieldName>;
    onSelected?: (value: string | number) => void;
    inputId?: string;
    isRequired?: boolean;
    "aria-label"?: string;
}

export const LicenceType = <TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>>({
    licenseTypes,
    isLoading,
    rules,
    onSelected,
    inputId,
    isRequired,
    "aria-label": ariaLabel,
    ...controllerProps
}: IProps<TFieldValues, TFieldName>) => {
    return (
        <FormSelect<TFieldValues, TFieldName>
            {...controllerProps}
            isLoading={isLoading}
            options={licenseTypes.map(t => ({ label: t.description, value: t.licenseTypeId }))}
            rules={rules}
            onSelected={onSelected}
            className="input-licence-type"
            isSearchable={true}
            aria-label={ariaLabel}
            aria-required={isRequired}
        />
    );
};
